import React, { useState, useEffect } from "react";
import {
  qhseBg,
  supplyWhipstocks1,
  supplyWhipstocks2,
  supplyWhipstocks3,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Whipstocks = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState("300px");

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? "200px" : "300px");
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: heroHeight,
        }}
      >
        <SubOtherHero title="Whipstocks" />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Content */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("WHIPSTOCK SYSTEM")}
            </p>
            <p className="mt-5 text-[20px] font-semibold text-[#141615]">
              {t("The main advantaged of our Whipstocks with hydraulic anchor")}
            </p>
            <ul className="mt-5 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>
                {t(
                  "Allows sidetrack without cementing and support for anchor setting"
                )}
              </li>
              <li>{t("Can be applied in cased and in open hole")}</li>
              <li>{t("Window milling for one trip")}</li>
              <li>{t("Simple and reliable design of the anchor")}</li>
              <li>
                {t(
                  "Equipment can be used in the intervals with angles up to 90 degree"
                )}
              </li>
              <li>
                {t(
                  "Possibility for direct and back circulation while Whipstock running"
                )}
              </li>
              <li>
                {t(
                  "The technology is highly effective technically and economically"
                )}
              </li>
              <li>
                {t(
                  "The competitive advantage of products – the best value for money"
                )}
              </li>
            </ul>
          </div>

          {/* Right Images */}
          <div className="md:w-1/2 grid grid-cols-2 gap-4 mt-8 md:mt-0">
            <img
              src={supplyWhipstocks1}
              alt="Whipstock 1"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyWhipstocks2}
              alt="Whipstock 2"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyWhipstocks3}
              alt="Whipstock 3"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Whipstocks;
